module.exports = __webpack_public_path__ + "img/9788952757241.902ed424.jpg";